import type { ComponentType } from 'react'
import { Text } from 'react-native'
import type { LucideProps } from 'lucide-react-native'
import { IconBadge } from '@chillout/ui'

interface AuthScreenHeaderProps {
  Icon: ComponentType<LucideProps>
  iconAccessibilityLabel: string
  title: string
  subtitle: string
}

export function AuthScreenHeader({
  Icon,
  iconAccessibilityLabel,
  title,
  subtitle,
}: AuthScreenHeaderProps) {
  return (
    <>
      <IconBadge
        Icon={Icon}
        accessibilityLabel={iconAccessibilityLabel}
        className="h-[84px] w-[84px] self-center sm:h-[96px] sm:w-[96px]"
        iconSize={58}
      />
      <Text className="mt-6 text-center text-2xl font-bold text-primary sm:mt-8 sm:text-3xl">
        {title}
      </Text>
      <Text className="mt-3 text-center text-sm font-normal text-secondary sm:mt-4 sm:text-base">
        {subtitle}
      </Text>
    </>
  )
}
